/**
 * DevExtreme (esm/renovation/common/config_context.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    createContext
} from "@devextreme/runtime/inferno";
export const ConfigContext = createContext(void 0);
